'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mergeOpts = require('merge-options');

var toMfsPath = require('./utils/to-mfs-path.js');

var debug = require('debug');

var errCode = require('err-code');

var ipfsUnixfs = require('ipfs-unixfs');

var toTrail = require('./utils/to-trail.js');

var addLink = require('./utils/add-link.js');

var updateTree = require('./utils/update-tree.js');

var updateMfsRoot = require('./utils/update-mfs-root.js');

var dagPB = require('@ipld/dag-pb');

var cid = require('multiformats/cid');

var itPipe = require('it-pipe');

var ipfsUnixfsImporter = require('ipfs-unixfs-importer');

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var last = require('it-last');

var cp = require('./cp.js');

var rm = require('./rm.js');

var persist = require('./utils/persist.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:touch');
var defaultOptions = {
  flush: true,
  shardSplitThreshold: 1000,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  recursive: false
};

function calculateModification(mode, originalMode, isDirectory) {
  var modification = 0;

  if (mode.includes('x') || mode.includes('X') && (isDirectory || originalMode & 1 || originalMode & 8 || originalMode & 64)) {
    modification += 1;
  }

  if (mode.includes('w')) {
    modification += 2;
  }

  if (mode.includes('r')) {
    modification += 4;
  }

  return modification;
}

function calculateUGO(references, modification) {
  var ugo = 0;

  if (references.includes('u')) {
    ugo += modification << 6;
  }

  if (references.includes('g')) {
    ugo += modification << 3;
  }

  if (references.includes('o')) {
    ugo += modification;
  }

  return ugo;
}

function calculateSpecial(references, mode, modification) {
  if (mode.includes('t')) {
    modification += parseInt('1000', 8);
  }

  if (mode.includes('s')) {
    if (references.includes('u')) {
      modification += parseInt('4000', 8);
    }

    if (references.includes('g')) {
      modification += parseInt('2000', 8);
    }
  }

  return modification;
}

function parseSymbolicMode(input, originalMode, isDirectory) {
  if (!originalMode) {
    originalMode = 0;
  }

  var match = input.match(/^(u?g?o?a?)(-?\+?=?)?(r?w?x?X?s?t?)$/);

  if (!match) {
    throw new Error("Invalid file mode: ".concat(input));
  }

  var _match = _slicedToArray(match, 4),
      references = _match[1],
      operator = _match[2],
      mode = _match[3];

  if (references === 'a' || !references) {
    references = 'ugo';
  }

  var modification = calculateModification(mode, originalMode, isDirectory);
  modification = calculateUGO(references, modification);
  modification = calculateSpecial(references, mode, modification);

  if (operator === '=') {
    if (references.includes('u')) {
      originalMode = originalMode & parseInt('7077', 8);
      originalMode = originalMode | modification;
    }

    if (references.includes('g')) {
      originalMode = originalMode & parseInt('7707', 8);
      originalMode = originalMode | modification;
    }

    if (references.includes('o')) {
      originalMode = originalMode & parseInt('7770', 8);
      originalMode = originalMode | modification;
    }

    return originalMode;
  }

  if (operator === '+') {
    return modification | originalMode;
  }

  if (operator === '-') {
    return modification ^ originalMode;
  }

  return originalMode;
}

function calculateMode(mode, metadata) {
  if (mode instanceof String || typeof mode === 'string') {
    var strMode = "".concat(mode);

    if (strMode.match(/^\d+$/g)) {
      mode = parseInt(strMode, 8);
    } else {
      mode = 0 + strMode.split(',').reduce(function (curr, acc) {
        return parseSymbolicMode(acc, curr, metadata.isDirectory());
      }, metadata.mode || 0);
    }
  }

  return mode;
}

function createChmod(context) {
  function mfsChmod(_x4, _x5) {
    return _mfsChmod.apply(this, arguments);
  }

  function _mfsChmod() {
    _mfsChmod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, mode) {
      var options,
          opts,
          _yield$toMfsPath$toMf,
          cid$1,
          mfsDirectory,
          name,
          root,
          block,
          node,
          metadata,
          updatedBlock,
          hashAlg,
          hasher,
          hash,
          updatedCid,
          trail,
          parent,
          parentCid,
          parentBlock,
          parentNode,
          result,
          newRootCid,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              opts = mergeOptions(defaultOptions, options);
              log("Fetching stats for ".concat(path));
              _context5.next = 5;
              return toMfsPath.toMfsPath(context, path, opts);

            case 5:
              _yield$toMfsPath$toMf = _context5.sent;
              cid$1 = _yield$toMfsPath$toMf.cid;
              mfsDirectory = _yield$toMfsPath$toMf.mfsDirectory;
              name = _yield$toMfsPath$toMf.name;

              if (!(cid$1.code !== dagPB__namespace.code)) {
                _context5.next = 11;
                break;
              }

              throw errCode__default["default"](new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

            case 11:
              if (!opts.recursive) {
                _context5.next = 22;
                break;
              }

              _context5.next = 14;
              return itPipe.pipe( /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _node;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iteratorAbruptCompletion = false;
                        _didIteratorError = false;
                        _context.prev = 2;
                        _iterator = _asyncIterator(ipfsUnixfsExporter.recursive(cid$1, context.repo.blocks));

                      case 4:
                        _context.next = 6;
                        return _awaitAsyncGenerator(_iterator.next());

                      case 6:
                        if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                          _context.next = 17;
                          break;
                        }

                        entry = _step.value;

                        if (!(entry.type !== 'file' && entry.type !== 'directory')) {
                          _context.next = 10;
                          break;
                        }

                        throw errCode__default["default"](new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

                      case 10:
                        entry.unixfs.mode = calculateMode(mode, entry.unixfs);
                        _node = dagPB__namespace.prepare({
                          Data: entry.unixfs.marshal(),
                          Links: entry.node.Links
                        });
                        _context.next = 14;
                        return {
                          path: entry.path,
                          content: _node
                        };

                      case 14:
                        _iteratorAbruptCompletion = false;
                        _context.next = 4;
                        break;

                      case 17:
                        _context.next = 23;
                        break;

                      case 19:
                        _context.prev = 19;
                        _context.t0 = _context["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _context.t0;

                      case 23:
                        _context.prev = 23;
                        _context.prev = 24;

                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                          _context.next = 28;
                          break;
                        }

                        _context.next = 28;
                        return _awaitAsyncGenerator(_iterator.return());

                      case 28:
                        _context.prev = 28;

                        if (!_didIteratorError) {
                          _context.next = 31;
                          break;
                        }

                        throw _iteratorError;

                      case 31:
                        return _context.finish(28);

                      case 32:
                        return _context.finish(23);

                      case 33:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 19, 23, 33], [24,, 28, 32]]);
              })), function (source) {
                return ipfsUnixfsImporter.importer(source, context.repo.blocks, _objectSpread(_objectSpread({}, opts), {}, {
                  pin: false,
                  dagBuilder: function () {
                    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source, block, opts) {
                      var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2;

                      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _iteratorAbruptCompletion2 = false;
                              _didIteratorError2 = false;
                              _context4.prev = 2;
                              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                                var entry;
                                return _regeneratorRuntime.wrap(function _loop$(_context3) {
                                  while (1) {
                                    switch (_context3.prev = _context3.next) {
                                      case 0:
                                        entry = _step2.value;
                                        _context3.next = 3;
                                        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                                          var node, buf, cid, unixfs;
                                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                            while (1) {
                                              switch (_context2.prev = _context2.next) {
                                                case 0:
                                                  node = entry.content;
                                                  buf = dagPB__namespace.encode(node);
                                                  _context2.next = 4;
                                                  return persist.persist(buf, block, opts);

                                                case 4:
                                                  cid = _context2.sent;

                                                  if (node.Data) {
                                                    _context2.next = 7;
                                                    break;
                                                  }

                                                  throw errCode__default["default"](new Error("".concat(cid, " had no data")), 'ERR_INVALID_NODE');

                                                case 7:
                                                  unixfs = ipfsUnixfs.UnixFS.unmarshal(node.Data);
                                                  return _context2.abrupt("return", {
                                                    cid: cid,
                                                    size: buf.length,
                                                    path: entry.path,
                                                    unixfs: unixfs
                                                  });

                                                case 9:
                                                case "end":
                                                  return _context2.stop();
                                              }
                                            }
                                          }, _callee2);
                                        }));

                                      case 3:
                                      case "end":
                                        return _context3.stop();
                                    }
                                  }
                                }, _loop);
                              });
                              _iterator2 = _asyncIterator(source);

                            case 5:
                              _context4.next = 7;
                              return _awaitAsyncGenerator(_iterator2.next());

                            case 7:
                              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                                _context4.next = 12;
                                break;
                              }

                              return _context4.delegateYield(_loop(), "t0", 9);

                            case 9:
                              _iteratorAbruptCompletion2 = false;
                              _context4.next = 5;
                              break;

                            case 12:
                              _context4.next = 18;
                              break;

                            case 14:
                              _context4.prev = 14;
                              _context4.t1 = _context4["catch"](2);
                              _didIteratorError2 = true;
                              _iteratorError2 = _context4.t1;

                            case 18:
                              _context4.prev = 18;
                              _context4.prev = 19;

                              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                                _context4.next = 23;
                                break;
                              }

                              _context4.next = 23;
                              return _awaitAsyncGenerator(_iterator2.return());

                            case 23:
                              _context4.prev = 23;

                              if (!_didIteratorError2) {
                                _context4.next = 26;
                                break;
                              }

                              throw _iteratorError2;

                            case 26:
                              return _context4.finish(23);

                            case 27:
                              return _context4.finish(18);

                            case 28:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee3, null, [[2, 14, 18, 28], [19,, 23, 27]]);
                    }));

                    return function dagBuilder(_x, _x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()
                }));
              }, function (nodes) {
                return last__default["default"](nodes);
              });

            case 14:
              root = _context5.sent;

              if (root) {
                _context5.next = 17;
                break;
              }

              throw errCode__default["default"](new Error("Could not chmod ".concat(path)), 'ERR_COULD_NOT_CHMOD');

            case 17:
              _context5.next = 19;
              return rm.createRm(context)(path, opts);

            case 19:
              _context5.next = 21;
              return cp.createCp(context)("/ipfs/".concat(root.cid), path, opts);

            case 21:
              return _context5.abrupt("return");

            case 22:
              _context5.next = 24;
              return context.repo.blocks.get(cid$1);

            case 24:
              block = _context5.sent;
              node = dagPB__namespace.decode(block);

              if (node.Data) {
                _context5.next = 28;
                break;
              }

              throw errCode__default["default"](new Error("".concat(cid$1, " had no data")), 'ERR_INVALID_NODE');

            case 28:
              metadata = ipfsUnixfs.UnixFS.unmarshal(node.Data);
              metadata.mode = calculateMode(mode, metadata);
              updatedBlock = dagPB__namespace.encode({
                Data: metadata.marshal(),
                Links: node.Links
              });
              hashAlg = opts.hashAlg || defaultOptions.hashAlg;
              _context5.next = 34;
              return context.hashers.getHasher(hashAlg);

            case 34:
              hasher = _context5.sent;
              _context5.next = 37;
              return hasher.digest(updatedBlock);

            case 37:
              hash = _context5.sent;
              updatedCid = cid.CID.create(opts.cidVersion, dagPB__namespace.code, hash);

              if (!opts.flush) {
                _context5.next = 42;
                break;
              }

              _context5.next = 42;
              return context.repo.blocks.put(updatedCid, updatedBlock);

            case 42:
              _context5.next = 44;
              return toTrail.toTrail(context, mfsDirectory);

            case 44:
              trail = _context5.sent;
              parent = trail[trail.length - 1];
              parentCid = cid.CID.decode(parent.cid.bytes);
              _context5.next = 49;
              return context.repo.blocks.get(parentCid);

            case 49:
              parentBlock = _context5.sent;
              parentNode = dagPB__namespace.decode(parentBlock);
              _context5.next = 53;
              return addLink.addLink(context, {
                parent: parentNode,
                name: name,
                cid: updatedCid,
                size: updatedBlock.length,
                flush: opts.flush,
                hashAlg: hashAlg,
                cidVersion: cid$1.version,
                shardSplitThreshold: Infinity
              });

            case 53:
              result = _context5.sent;
              parent.cid = result.cid;
              _context5.next = 57;
              return updateTree.updateTree(context, trail, opts);

            case 57:
              newRootCid = _context5.sent;
              _context5.next = 60;
              return updateMfsRoot.updateMfsRoot(context, newRootCid, opts);

            case 60:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4);
    }));
    return _mfsChmod.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsChmod);
}

exports.createChmod = createChmod;